export default function Edit({ style }) {
  return (
    <svg
      className={style}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <g clipPath='url(#clip0_3166_25108)'>
        <path
          d='M13.2606 3.59924L5.05058 12.2892C4.74058 12.6192 4.44058 13.2692 4.38058 13.7192L4.01058 16.9592C3.88058 18.1292 4.72058 18.9292 5.88058 18.7292L9.10058 18.1792C9.55058 18.0992 10.1806 17.7692 10.4906 17.4292L18.7006 8.73924C20.1206 7.23924 20.7606 5.52924 18.5506 3.43924C16.3506 1.36924 14.6806 2.09924 13.2606 3.59924Z'
          stroke='white'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M11.8899 5.05078C12.3199 7.81078 14.5599 9.92078 17.3399 10.2008'
          stroke='white'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3 22H21'
          stroke='white'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_3166_25108'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
